//@flow
import React from 'react';
import {CircularProgress, Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {useTriggerExecutionSimulate} from '../utils';

type Props = {|
  triggerId: ?string,
  enabled?: boolean,
  compact?: boolean,
|};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
  },
  text: {
    fontSize: '0.875rem',
    color: colors.grey700,
  },
  compactText: {
    fontSize: '0.8125rem',
    color: colors.grey700,
  },
  value: {
    fontWeight: 600,
    color: colors.grey900,
  },
}));

export default function TriggerSimulateEstimate({
  triggerId,
  enabled = true,
  compact = false,
}: Props) {
  const classes = useStyles();
  const {estimatedCount, loading, error} = useTriggerExecutionSimulate(
    triggerId,
    {
      enabled: Boolean(enabled && triggerId),
    }
  );

  if (!enabled || !triggerId) return null;

  if (loading) {
    return (
      <div className={classes.root}>
        <CircularProgress size={14} />
        <Typography className={compact ? classes.compactText : classes.text}>
          Estimando conversaciones...
        </Typography>
      </div>
    );
  }

  if (error) {
    return (
      <Typography className={compact ? classes.compactText : classes.text}>
        No se pudo estimar el alcance
      </Typography>
    );
  }

  if (estimatedCount == null) return null;

  return (
    <div className={classes.root}>
      <Typography className={compact ? classes.compactText : classes.text}>
        Estimado:{' '}
        <span className={classes.value}>
          {estimatedCount}{' '}
          {estimatedCount === 1 ? 'conversación' : 'conversaciones'}
        </span>
      </Typography>
    </div>
  );
}
